(function () {
  const menu = document.getElementById('customContextMenu');
  const toast = document.getElementById('customContextToast');

  if (!menu) {
    console.log('customContextMenu not found');
    return;
  }

  console.log('custom context menu loaded');

  const itemCopyText = menu.querySelector('[data-action="copy-text"]');
  const itemOpenLink = menu.querySelector('[data-action="open-link"]');
  const itemCopyLink = menu.querySelector('[data-action="copy-link"]');
  const itemOpenImage = menu.querySelector('[data-action="open-image"]');
  const itemCopyImage = menu.querySelector('[data-action="copy-image"]');
  const itemOpenVideo = menu.querySelector('[data-action="open-video"]');
  const itemCopyVideo = menu.querySelector('[data-action="copy-video"]');
  //const itemShareVideo = menu.querySelector('[data-action="share-video"]');
  const separatorText = menu.querySelector('.ccm-separator-text');

  let context = {
    text: '',
    linkUrl: '',
    imageUrl: '',
    videoUrl: ''
  };

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(window.__ccmToastTimer);
    window.__ccmToastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 1500);
  }

  function hideMenu() {
    menu.classList.remove('is-open');
    menu.style.display = 'none';
    menu.setAttribute('aria-hidden', 'true');
  }

  function showMenu(x, y) {
    menu.style.display = 'block';
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');

    const rect = menu.getBoundingClientRect();
    let left = x;
    let top = y;

    if (left + rect.width > window.innerWidth) {
      left = window.innerWidth - rect.width - 10;
    }

    if (top + rect.height > window.innerHeight) {
      top = window.innerHeight - rect.height - 10;
    }

    menu.style.left = `${left + window.scrollX}px`;
    menu.style.top = `${top + window.scrollY}px`;
  }

  function getSelectedText(target) {
    if (
      target &&
      (target.tagName === 'TEXTAREA' ||
        (target.tagName === 'INPUT' &&
          /^(text|search|url|tel|password|email)$/i.test(target.type)))
    ) {
      const start = target.selectionStart || 0;
      const end = target.selectionEnd || 0;
      return (target.value || '').slice(start, end).trim();
    }

    return window.getSelection ? window.getSelection().toString().trim() : '';
  }

  function getVideoUrl(videoEl) {
    if (!videoEl) return '';

    if (videoEl.currentSrc) return videoEl.currentSrc;
    if (videoEl.src) return videoEl.src;

    const source = videoEl.querySelector('source[src]');
    return source ? source.src : '';
  }

  function canShareUrl(url) {
    if (!navigator.share || !url) return false;

    if (navigator.canShare) {
      try {
        return navigator.canShare({ url: url });
      } catch (e) {
        return false;
      }
    }

    return true;
  }

  function getContextTargets(e) {
    const target = e.target;
    const stack = document.elementsFromPoint
      ? document.elementsFromPoint(e.clientX, e.clientY)
      : [target];

    let link = null;
    let image = null;
    let video = null;

    for (const el of stack) {
      if (!link && el.closest) {
        const foundLink = el.closest('a[href]');
        if (foundLink) link = foundLink;
      }

      if (!image && el.tagName === 'IMG') {
        image = el;
      }

      if (!video && el.tagName === 'VIDEO') {
        video = el;
      }

      if (link && image && video) break;
    }

    if (!link && target.closest) {
      link = target.closest('a[href]');
    }

    if (!image && target.closest) {
      image = target.closest('img');
    }

    if (!video && target.closest) {
      video = target.closest('video');
    }

    return { target, link, image, video };
  }

  function updateItems() {
    const hasText = !!context.text;
    const hasLink = !!context.linkUrl;
    const hasImage = !!context.imageUrl;
    const hasVideo = !!context.videoUrl;
    //const canShareVideo = hasVideo && canShareUrl(context.videoUrl);

    itemCopyText.hidden = !hasText;
    itemOpenLink.hidden = !hasLink;
    itemCopyLink.hidden = !hasLink;
    itemOpenImage.hidden = !hasImage;
    itemCopyImage.hidden = !hasImage;
    itemOpenVideo.hidden = !hasVideo;
    itemCopyVideo.hidden = !hasVideo;
    //itemShareVideo.hidden = !canShareVideo;

    separatorText.hidden = !(hasText && (hasLink || hasImage || hasVideo));
  }

  async function copyText(value) {
    await navigator.clipboard.writeText(value);
    showToast('Copied');
  }

  async function copyImage(url) {
    let finalUrl = url;

    if (url.includes("cdn.shopify") && url.includes("files/")) {
        const lastPart = url.split("files/").pop();
        finalUrl = `https://libandco.com/cdn/shop/files/${lastPart}`;
    }

    try {
        const res = await fetch(finalUrl);
        const blob = await res.blob();

        if (window.ClipboardItem && navigator.clipboard.write) {
        await navigator.clipboard.write([
            new ClipboardItem({ [blob.type]: blob })
        ]);
        showToast('Image copied');
        } else {
        await navigator.clipboard.writeText(finalUrl);
        showToast('Image URL copied');
        }
    } catch (e) {
        console.error(e);
        await navigator.clipboard.writeText(finalUrl);
        showToast('Image URL copied');
    }
  }

  async function shareVideo(url) {
    try {
        if (url.includes("cdn.shopify")) {
            const url_parts = url.split("videos/");
            const last_part = url_parts[url_parts.length - 1];
            await navigator.share({
                title: document.title || 'Video',
                text: '',
                url: `https://libandco.com/cdn/shop/videos/${last_part}`
            });
        }
        else {
            await navigator.share({
                title: document.title || 'Video',
                text: '',
                url: url,
            });
        }
      showToast('Share opened');
    } catch (e) {
      if (e && e.name === 'AbortError') {
        return;
      }

      console.error(e);
      await navigator.clipboard.writeText(url);
      showToast('Video URL copied');
    }
  }

  document.addEventListener(
    'contextmenu',
    function (e) {
      const targets = getContextTargets(e);

      context.text = getSelectedText(targets.target);
      context.linkUrl = targets.link ? targets.link.href : '';
      context.imageUrl = targets.image
        ? (targets.image.currentSrc || targets.image.src || '')
        : '';
      context.videoUrl = getVideoUrl(targets.video);

      e.preventDefault();
      e.stopPropagation();

      updateItems();

      if (!context.text && !context.linkUrl && !context.imageUrl && !context.videoUrl) {
        hideMenu();
        return;
      }

      showMenu(e.clientX, e.clientY);
    },
    true
  );

  function normalizeShopifyUrl(url) {
    if (!url || !url.includes("cdn.shopify")) return url;

    if (url.includes("files/")) {
        return `https://libandco.com/cdn/shop/files/${url.split("files/").pop()}`;
    }

    if (url.includes("videos/")) {
        return `https://libandco.com/cdn/shop/videos/${url.split("videos/").pop()}`;
    }

    return url;
    }

  menu.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-action]');
    if (!btn) return;

    const action = btn.getAttribute('data-action');

    try {
      if (action === 'copy-text' && context.text) {
        await copyText(context.text);
      }

      if (action === 'open-link' && context.linkUrl) {
        window.open(normalizeShopifyUrl(context.linkUrl), '_blank', 'noopener');
      }

      if (action === 'copy-link' && context.linkUrl) {
        await copyText(normalizeShopifyUrl(context.linkUrl));
      }

      if (action === 'open-image' && context.imageUrl) {
        if (context.imageUrl.includes("cdn.shopify")) {
            const url_parts = context.imageUrl.split("files/");
            const last_part = url_parts[url_parts.length - 1];
            window.open(`https://libandco.com/cdn/shop/files/${last_part}`, '_blank', 'noopener');            
        }
        else {
            window.open(context.imageUrl, '_blank', 'noopener');            
        }
      }

      if (action === 'copy-image' && context.imageUrl) {
        await copyImage(context.imageUrl);
      }

      if (action === 'open-video' && context.videoUrl) {
        if (context.videoUrl.includes("cdn.shopify")) {
            const url_parts = context.videoUrl.split("videos/");
            const last_part = url_parts[url_parts.length - 1];
            window.open(`https://libandco.com/cdn/shop/videos/${last_part}`, '_blank', 'noopener');            
        }
        else {
            window.open(context.videoUrl, '_blank', 'noopener');            
        }
      }

      if (action === 'copy-video' && context.videoUrl) {
        if (context.videoUrl.includes("cdn.shopify")) {
            const url_parts = context.videoUrl.split("videos/");
            const last_part = url_parts[url_parts.length - 1];
            await copyText(`https://libandco.com/cdn/shop/videos/${last_part}`);          
        }
        else {
            await copyText(context.videoUrl);           
        }
        showToast('Video URL copied');
      }

      /*if (action === 'share-video' && context.videoUrl) {
        await shareVideo(context.videoUrl);
      }*/
    } catch (err) {
      console.error(err);
      showToast('Action failed');
    }

    hideMenu();
  });

  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target)) hideMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideMenu();
  });

  window.addEventListener('blur', hideMenu);
  window.addEventListener('resize', hideMenu);
})();